import React, {Component} from 'react'
import PrintPreview from '../PrintPreview'
import PdfStore from 'stores/PdfStore'
import { momentHelper } from '../../report/helpers'
// import FontAwesome from 'react-fontawesome'

const month = momentHelper.getMonth()
const year = momentHelper.getYear()
const day = momentHelper.getDay()
const DEFAULT_ROW = 30
class PrintZongTaxInvoiceCoverNoteInsurer extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:{},dataList:[],report_title:'กำลังดึงข้อมูล..'}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    let {data,dataList} = this.state
    PdfStore.loadTaxInvoiceCoverNoteDoc(this.props.tivList,(result) => {
      data = result.data
      dataList = this.getPagination(result.data.list)     
      this.setState({data:data,dataList:dataList,report_title:'ไม่พบข้อมูล'})
    })
  }

  renderSignature() {
    return(
      <table className='table table-header-print-kkc-billing-note'>
        <tbody>
          <tr>
            <td className='text-center'>ลงชื่อ..............................ผู้วางบิล</td>
            <td className='text-center'>ลงชื่อ..............................ผู้รับวางบิล</td>
            <td className='text-center'>ลงชื่อ..............................ผู้บันทึก</td>
          </tr>
          <tr>
            <td className='text-center'>{'วันที่ '+day+'/'+month+'/'+year}</td>
            <td className='text-center'>วันที่........./........./.........</td>
            <td className='text-center'>วันที่........./........./.........</td>
          </tr>
        </tbody>
      </table>
    )  
  }

  renderHeader() {
    let {data} = this.state
    let {showTaxinvoice} = this.props
    return(
      <table className='table table-header-print-kkc-billing-note' style={{marginBottom:'0'}}>
        <tbody>
          <tr>
            <td>ชื่อบริษัท <span className='color-pink'>{data.customer!==undefined?data.customer.customer_name:''}</span></td>
            <td className='text-right'>{'วันที่ '+day+'/'+month+'/'+year}</td>
          </tr>
          {showTaxinvoice
          ?<tr><td colSpan={2} className='text-right'>{'เลขที่ใบวางบิล '+(data.taxinvoice_cn_id!==undefined?data.taxinvoice_cn_id:'')}</td></tr>
          :<tr style={{display:'none'}}><td colSpan={2}></td></tr>}
        </tbody>
      </table>
    )
  }

  renderEmptySpace(){
    return (<br/>)
  }

  renderRowData(item) {
    let {showTaxinvoice} = this.props
    if (item.length===0) {
      return(
        <tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>
      )
    } else {
      return(
        item.map((item,index) => {
          return(
            <tr key={index}>
              {showTaxinvoice
              ?
              <td className='text-center'>{item.taxinvoice_no!=''?item.taxinvoice_no:this.renderEmptySpace()}</td>
              :
              <td className='text-center'>{item.vehicle_code!=''?item.vehicle_code:this.renderEmptySpace()}</td>
              }
              <td className='text-center font-print-14'>{item.claim_no}</td>
              <td className='text-center font-print-14'>{item.insurance_policy_no}</td>
              <td className='text-center font-print-14'>{item.car_registration_no}</td>
              <td className='text-center font-print-14'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-center font-print-14'>{item.remark}</td>
            </tr>
          )
        })  
      )    
    }      
  }

  // renderTable(item) {
  //   let {showTaxinvoice} = this.props
  //   return(
  //     <div className=''>
  //       <table className='table table-hover table-bordered-solid table-print-kkc-billing-note'>
  //         <thead>
  //           <tr>
  //             <th className='text-center bg-none' style={{width:'100px'}}>{showTaxinvoice?'ใบกำกับภาษี':'รหัส'}</th>
  //             <th className='text-center bg-none' style={{width:'100px'}}>ยี่ห้อ</th>
  //             <th className='text-center bg-none' style={{width:'110px'}}>ทะเบียน</th>
  //             <th className='text-center bg-none' style={{width:'90px'}}>ป/ค</th>
  //             <th className='text-center bg-none' style={{width:'150px'}}>เลขเคลม</th>
  //             <th className='text-center bg-none' style={{width:'150px'}}>เลขกรมธรรม์</th>
  //             <th className='text-center bg-none' style={{width:'150px'}}>ราคา</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           {this.renderRowData(item)}
  //         </tbody>
  //         <tfoot>
  //           <tr>
  //             <th className='text-center bg-none br-b-none br-l-none' colSpan={5}></th>
  //             <th className='text-center bg-none'>รวมราคา</th>
  //             <th className='text-right bg-none color-pink'>{this.getNumberFormat(this.getSummary())}</th>
  //           </tr>
  //         </tfoot>
  //       </table>
  //     </div>
  //   )      
  // }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    return ''
  }

  getSummary() {
    let {data} = this.state
    let sum = 0
    data.list.forEach(function(item,index) {
      let amount = item.amount
      if (amount===''||amount===null||amount===undefined||isNaN(amount))
        amount = 0

      sum += parseFloat(amount)
    })
    return sum
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderCompany(copyType,index) {
    let {data} = this.state
    let copyTitle = copyType!==undefined?(copyType==='original'?'ต้นฉบับ':'สำเนา'):index===0?'ต้นฉบับ':'สำเนา'
    return(
      [ 
        <header key={'h-'+index}>
          <h2>{this.props.title}</h2>
        </header>,
        <article className={"article-company "+data.logo_class} key={'a-'+index}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-18" style={{width:'85%',paddingTop:(data.logo_class=='bg-logo-absolute'?'0':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>             
            </strong>
          </section>
          <section className='text-right sec-copy-doc'>
            <span>{copyTitle}</span>
          </section>
        </article>
      ]
    )
  }

  renderAll(item) {
    let {data} = this.state
    return(
      item.list.map((sub_item,index) => {
        return(
          <div key={index}>
            <header className='text-center'>
              <h2>{this.props.title}</h2>
            </header>
            <div className='text-center'>บริษัท เทเวสประกันภัยจำกัด (มหาชน)</div>
            <br />
            <table className='table table-header-print-kkc-billing-note'>
              <tbody>
                <tr>
                  <td style={{width:'60px'}}>ชื่อ อู่/บริษัท</td>
                  <td style={{width:'150px',borderBottom:'2px dotted #111'}}>{data.company_name}</td>
                  <td style={{width:'20px'}}></td>
                  <td style={{width:'60px'}}>วันที่นัดจ่าย</td>
                  <td style={{width:'150px',borderBottom:'2px dotted #111'}}></td>
                </tr>
                <tr>
                  <td>โทร.</td>
                  <td style={{borderBottom:'2px dotted #111'}}>{data.tel}</td>
                  <td></td>
                  <td colSpan={2}>รับเช็คที่ฝ่ายบัญชีและการเงิน/ธนาคารซิตี้แบงค์</td>
                </tr>
              </tbody>
            </table>
            <table className='table table-hover table-bordered-solid table-print-kkc-billing-note'>
              <thead>
                <tr>
                  <th className='text-center bg-none' style={{width:'100px'}}>ลำดับ</th>
                  <th className='text-center bg-none' style={{width:'100px'}}>เลขที่/เลขเคลม</th>
                  <th className='text-center bg-none' style={{width:'110px'}}>กรมธรรม์</th>
                  <th className='text-center bg-none' style={{width:'90px'}}>ทะเบียนรถ</th>
                  <th className='text-center bg-none' style={{width:'150px'}}>จำนวนเงิน</th>
                  <th className='text-center bg-none' style={{width:'150px'}}>หมายเหตุ</th>
                </tr>
              </thead>
              <tbody>
                {this.renderRowData(sub_item)}
              </tbody>
            </table>
            <div>
              <div style={{width:'60%',display:'inline-flex'}}>
                <table className='table table-header-print-kkc-billing-note'>
                  <tbody>
                    <tr>
                      <td style={{width:'80px'}}>ลงชื่อ</td>
                      <td style={{width:'120px',borderBottom:'2px dotted #111'}}></td>
                      <td colSpan={3}>ผู้วางบิล</td>
                    </tr>
                    <tr>
                      <td>วันที่วางบิล</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'40px'}}>จำนวน</td>
                      <td style={{width:'80px',borderBottom:'2px dotted #111'}}></td>
                      <td>เรื่อง</td>
                    </tr>
                    <tr>
                      <td>ลงชื่อ</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td colSpan={3}>ผู้รับวางบิล</td>
                    </tr>
                    <tr>
                      <td>วันที่รับวางบิล</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td>จำนวน</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td>เรื่อง</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div style={{width:'40%',display:'inline-flex',border:'1px solid #111'}}>
                <table className='table table-header-print-kkc-billing-note'>
                  <tbody>
                    <tr>
                      <td className='text-center' colSpan={4}>อนุมัติ Payment ในระบบ</td>
                    </tr>
                    <tr>
                      <td style={{width:'80px'}}>ผจก.</td>
                      <td style={{width:'120px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'40px'}}>วันที่</td>
                      <td style={{width:'100px',borderBottom:'2px dotted #111'}}></td>
                    </tr>
                    <tr>
                      <td>รอง ผอ.</td>
                      <td style={{width:'120px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'40px'}}>วันที่</td>
                      <td style={{width:'100px',borderBottom:'2px dotted #111'}}></td>
                    </tr>
                    <tr>
                      <td>ผอ. ฝ่าย</td>
                      <td style={{width:'120px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'40px'}}>วันที่</td>
                      <td style={{width:'100px',borderBottom:'2px dotted #111'}}></td>
                    </tr>
                    <tr>
                      <td>ผช. กจก.</td>
                      <td style={{width:'120px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'40px'}}>วันที่</td>
                      <td style={{width:'100px',borderBottom:'2px dotted #111'}}></td>
                    </tr>
                  </tbody>
                </table>    
              </div>
            </div>  
            <div>
              <div style={{width:'60%',display:'inline-flex'}}>
                <table className='table table-header-print-kkc-billing-note'>
                  <tbody>
                    <tr>
                      <td style={{width:'50px'}}>ส่งคีย์</td>
                      <td style={{width:'100px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'80px'}}>เรื่อง/อนุมัติ</td>
                      <td style={{width:'80px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'80px'}}>เรื่อง/อนุมัติ</td>
                      <td style={{width:'80px',borderBottom:'2px dotted #111'}}></td>
                      <td style={{width:'50px'}} className='text-right'>เรื่อง</td>
                    </tr>
                    <tr>
                      <td>วันที่</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td>/วันที่</td>
                      <td style={{borderBottom:'2px dotted #111'}}></td>
                      <td>/วันที่</td>
                      <td colSpan={2} style={{borderBottom:'2px dotted #111'}}></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>  
          </div>
        )
      })
    )  
  }

  renderComponentPage(item,index,total) {
    return(
      <div className='font-print' key={index}>
        {this.renderAll(item)}
      </div>  
    )
  }

  getPagination(data) {
    let allData = []
    let setData = []

    if (data.length<DEFAULT_ROW) {
      for (var i=data.length;i<DEFAULT_ROW;i++) {
        data.push({
          car_registration_no:'',
          invoice_no:'',
          brand:'',
          taxinvoice_no:'',
          amount:'',
          purchase_order_no:'',
          work_no:'',
          claim_no:'',
          quotation_no:'',
          opposite_car:'',
          insurance_policy_no:'',
          vehicle_code:''
        })
      }
    }

    if (data.length>DEFAULT_ROW) {
      setData.push(data)
      allData.push({
        list: setData,
        page: false,
        copyType:'original'
      })
      // allData.push({
      //   list: setData,
      //   page: false,
      //   copyType:'copy'
      // })
    } else {
      setData.push(data)
      // setData.push(data)
      allData.push({
        list: setData,
        page: 1
      })
    }

    return allData
  }

  renderNoData() {
    return(
      <div className='font-print'>
        <header className="text-center">
          <h2>{this.state.report_title}</h2>
        </header>
      </div>
    )
  }

  render() {
    let {loading,dataList} = this.state
    if (dataList.length===0) {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
        >
          {this.renderNoData()}
        </PrintPreview>
      )  
    } else {
      return(
        <PrintPreview 
          loading={loading}
          leftBarTitle={this.props.title}
          showPageNumber={false}
        >
          {
            dataList.map((item,index) => {
              return(
                this.renderComponentPage(item,index,dataList.length)
              )
            })
          }
        </PrintPreview>
      )
    }  
  }

}  

PrintZongTaxInvoiceCoverNoteInsurer.defaultProps = {
  title: 'ใบวางบิล',  
  mode: '1',
  showTaxinvoice: false, 
  showCoverNoteId: ''
}
export default PrintZongTaxInvoiceCoverNoteInsurer;


// WEBPACK FOOTER //
// ./src/view/print/zong/PrintZongTaxInvoiceCoverNoteInsurer.js